(function($) {

	'use strict';

	$(document).ready(function() {

		// scrollTop
		$('.ce_toplink a, .toplink a, .up a, .action-popup').on('click', function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop: 0}, 800);

			return false;
		});

		// Placeholder
		var $placeholder = $('input, textarea');
		if ($placeholder.length) {
			$placeholder.placeholder();
		}

		// mobile navigation
		var $navbtn = $('.nav-btn');
		if ($navbtn.length) {
			$navbtn.on('click', function(e){
				e.preventDefault();
				$('.nav-main').toggleClass('nav-open');
			});
		}

		// Popup
		$('.modal').detach().appendTo('body');

		// datepicker
		var $datepicker = $('input.datepicker');
		if ($datepicker.length) {
			var docLang = $('html').attr('lang');
			if (docLang === 'en') {
				docLang = 'en-GB';
			}

			$.datepicker.setDefaults($.datepicker.regional[docLang]);
			$datepicker.datepicker();
		}

		// extend filter
		var $extended = $('.extended');
		if ($extended.length) {
			$extended.hide();
			$('.extend').on('click', function(e) {
				e.preventDefault();
				$(this).toggleClass('active');
				$extended.slideToggle();
			});
		}

		// touch
		$('body').bind('touchstart', function() {});

		// matchHeight
		$('.match-height').matchHeight();

		// Countdown

		// 2 Hours
		function getTime() {
			return new Date(new Date().valueOf() + 1 * 2 * 60 * 60 * 1000);
		}

		$('.countdown').countdown(getTime(), function(event) {
			$(this).html(event.strftime('%H:%M:%S'));
		});

	});
})(jQuery);
